import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchStats } from '@uncinc/react-searchkit';
import type { SearchStatsProps } from '@uncinc/react-searchkit/dist/components/Stats';

const SearchGeneralStats: React.FC<SearchStatsProps> = (props) => {
  const { className, ...restProps } = props;

  const { t } = useTranslation();

  const classNames = c('search--results-count', 'SearchGeneral__Stats', className);

  return (
    <SearchStats
      {...restProps}
      className={classNames}
      translation={(numberOfHits: number) => t('components.search_general.stats.total_results', { count: numberOfHits })}
    />
  );
};

export default SearchGeneralStats;
